import { render, staticRenderFns } from "./PolizaDeApertura.vue?vue&type=template&id=ec9aa196&"
import script from "./PolizaDeApertura.vue?vue&type=script&lang=js&"
export * from "./PolizaDeApertura.vue?vue&type=script&lang=js&"
import style0 from "./PolizaDeApertura.vue?vue&type=style&index=0&id=ec9aa196&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QUploader from 'quasar/src/components/uploader/QUploader.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QDialog,QCardSection,QToolbar,QBtn,QTooltip,QToolbarTitle,QSeparator,QSelect,QUploader,QTable,QTr,QTd});
